export default __webpack_public_path__ + "static/media/2P_4G.b2b553a9.png";